/* angular:styles/component:css;4ad4b43e4f5228bfb5a8f213cfdc0d1f75f110e4da17192f9920a8ac8603cfe0;/usr/src/app/src/app/core/layout/main-layout/main-layout.component.ts */
.app-wrapper {
  min-height: 100vh;
}
.content {
  flex: 1;
}
/*# sourceMappingURL=main-layout.component.css.map */
